import { trimPipes, milOrBil, sanitize, isEmpty, convertToClass } from "../../_js/common/_util";
import { GMAP_API_KEY, googleSheets } from "../../_js/common/_variables";
import Filter from "../filter/filter";

("use strict");

export default class DataListCard {
    constructor() {}

    generateDataListCardHTML(el) {
        let dataListCardHTML = "";

        dataListCardHTML += `<div class="data-list-card-wrap">
            <div class="data-list-card">
                <div class="data-list-card__header">
                    <i aria-hidden="true" class="data-list-card__logo __icon -${sanitize(convertToClass(trimPipes(el[2])))} ${!isEmpty(el[16]) || el[16] === "TRUE" ? '-highlighted' : ''}"></i>`;
                    if (!isEmpty(el[2])){
                        dataListCardHTML += `<div class="data-list-card__title">${trimPipes(el[2])}</div>`;
                    }
                    if (!isEmpty(el[1])) {
                        dataListCardHTML += `<a href="#/company/${trimPipes(sanitize(el[1]))}" class="data-list-card__company-name">${trimPipes(el[1])}</a>`;
                    }

                dataListCardHTML += `</div>
                <div class="data-list-card__details">
                    <ul>`;
                        if (!isEmpty(el[8])) {
                            dataListCardHTML += `<li class="data-list-card__label"><span>Label</span>${el[8]}</li>`;
                        }
                        if (!isEmpty(el[9]) && el[2].includes('Cable')) {

                            dataListCardHTML += `<li class="data-list-card__year-commenced"><span>RFS</span>${el[9]}</li>`;
                        }
                        else if(!isEmpty(el[9]))
                        {
                            dataListCardHTML += `<li class="data-list-card__year-commenced"><span>Year</span>${el[9]}</li>`;

                        }
                        if (!isEmpty(el[4])) {
                            dataListCardHTML += `<li class="data-list-card__country"><span>Country</span>${trimPipes(el[4])}</li>`;
                        }                
                        if (!isEmpty(el[0])) {
                            dataListCardHTML += `<li class="data-list-card__map-link"><a href="#/map/marker-${el[0]}" title="Show pin on map">map link</a></li>`;
                        }
                    dataListCardHTML += `</ul>`

                    if (!isEmpty(el[17]) && el[2].includes('Cable') ) {
                        dataListCardHTML += `<div class="data-list-card__ownership"><span>Owned By : </span>${el[17]}</div>`;
                    }
                    if (!isEmpty(el[14])) {
                        dataListCardHTML += `<div class="data-list-card__description">${el[14]}</div>`;
                    }
                dataListCardHTML += `</div>
            </div>
        </div>`;
                    //avoid the empty company card and won't the data count
                    if((!isEmpty(el[2]))){
                        return dataListCardHTML;
                    }
                        else{
                        return "";
                    }
    }
}
